<template>
    <div class="wrap">
        <div class="innerBox" >
            <div>
              <el-input placeholder="姓名、账号、运营城市" class="w300 seekIpt" v-model="searchInput" @keyup.enter.native="search">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
              </el-input>
              <el-select class="ml20 w120" v-model="availableValue" @change="stateChange" clearable size="small" placeholder="启用状态">
                  <el-option v-for="item in availableTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <div>
              <el-button class="mt20" @click="add" icon="el-icon-circle-plus-outline" type="primary">添加</el-button>
              <el-button class="ml20" @click="batch('批量启用')" :disabled="isDisabled" type="primary">批量启用</el-button>
              <el-button class="ml20" @click="batch('批量禁用')" :disabled="isDisabled" type="primary">批量禁用</el-button>
            </div>
            <div>
                <el-table :data="tableData" border style="width:calc(100% - 10px); margin-top: 10px" :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}" v-loading="tableLoading" @selection-change="handleSelectionChange">
                    <el-table-column label="序号" width="80" type="selection" >
                    </el-table-column>
                    <el-table-column prop="TODO" label="姓名" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.TODO ? scope.row.TODO: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="TODO" label="账号" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.TODO ? scope.row.TODO: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="TODO" label="运营城市" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.TODO ? scope.row.TODO: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="TODO" label="更新时间" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.TODO ? scope.row.TODO: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="TODO" label="创建时间" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.TODO ? scope.row.TODO: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="available" label="启用禁用" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.available ? scope.row.available: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" min-width="270">
                        <template slot-scope="scope">
                            <el-button @click="updatePwd(scope.row)" type="primary" plain size="small">修改密码</el-button>
                            <el-button @click="edit(scope.row)" type="primary" plain size="small">编辑</el-button>
                            <el-button v-if="scope.row.available === '启用'" key="unAvailable" @click="useChange(scope.row)" type="danger" plain size="small">禁用</el-button>
                            <el-button v-else key="available" @click="useChange(scope.row)" type="warning" plain size="small">启用</el-button>
                        </template>
                    </el-table-column>    
                </el-table>
            </div>

            <el-dialog v-if="addDialogVisible" :visible.sync="addDialogVisible" :close-on-click-modal="false" :title="addTitle" style="padding-top: 0px;">
                <el-form :model="accountData" :rules="dataRules" ref="accountData" class="ml20 mr20" label-position="right" label-width="150px">
                    <div class="item">
                        <el-form-item label="姓名" prop="name">
                            <el-input class="w300" placeholder="请输入姓名, 20字以内" maxlength="20" clearable v-model="accountData.name"></el-input>
                        </el-form-item>
                        <el-form-item label="状态" prop="availableValue">
                            <el-select class="w300" v-model="accountData.availableValue" @change="stateChange" clearable size="small" placeholder="请选择启用状态">
                                <el-option v-for="item in availableTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="运营城市" prop="city">
                            <el-select class="w300" v-model="accountData.city" @change="cityChange" clearable size="small" placeholder="请选择运营城市">
                                <el-option v-for="item in citys" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="footer">
                    <el-button @click="cancleAccount" round>关闭</el-button>
                    <el-button type="primary" @click="submitAccount('pwdData')" round>保存</el-button>
                </div>
            </el-dialog>

            <el-dialog v-if="pwdDialogVisible" :visible.sync="pwdDialogVisible" :close-on-click-modal="false" title="修改密码" style="padding-top: 0px;">
                <el-form :model="pwdData" :rules="pwdDataRules" ref="pwdData" class="ml20 mr20" label-position="right" label-width="150px">
                    <div class="item">
                        <el-form-item label="新密码：" prop="newPwd">
                            <el-input class="w300" placeholder="请输入新密码, 20字以内" maxlength="20" clearable v-model="pwdData.newPwd"></el-input>
                        </el-form-item>
                        <el-form-item label="确认新密码：" prop="confirmPwd">
                            <el-input class="w300" placeholder="请再次输入新密码, 20字以内" maxlength="20" clearable v-model="pwdData.confirmPwd"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="footer">
                    <el-button @click="canclePwd" round>关闭</el-button>
                    <el-button type="primary" @click="submitPwd('pwdData')" round>保存</el-button>
                </div>
            </el-dialog>
            <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:10px;margin-right:10px"></ybPagination>
        </div>
    </div>
</template>
<script>

import ybPagination from '@/components/ybPagination';
import * as mapping from '@/utils/enumList'
export default {
    name: 'subjectList',
    components: {
        ybPagination,
    },
    data() {
        return {
            searchInput: '',
            availableTypes: mapping.getKeyVal('available'),
            availableValue: '',
            city: '',
            citys: '',
            updateParams: {
                entityId: '',
                available: ''
            },
            tableLoading: false,
            tableData: [{}],
            page: {
                pageSize: 10,
                pageNum: 1,
                total: 10
            },
            entityIdStr: '',
            addTitle: '添加',
            addDialogVisible: false,
            pwdDialogVisible: false,
            pwdDataRules: {
                newPwd: [
                    { required: true, message: '请输入新密码, 20字以内', trigger: 'blur' }
                ],
                confirmPwd: [
                    { required: true, message: '请再次输入新密码, 20字以内', trigger: 'blur' }
                ]
            },
            pwdData: {
                newPwd: '',
                confirmPwd: ''
            },
            accountData: {
              name: '',
              availableValue: '',
              city: ''
            },
            dataRules: {
              name: [
                  { required: true, message: '请输入姓名, 20字以内', trigger: 'blur' }
              ],
              availableValue: [
                  { required: true, message: '请选择启用状态', trigger: 'change' }
              ],
              city: [
                  { required: true, message: '请选择运营城市', trigger: 'change' }
              ]
            }
        }
    },
    computed: {
        isDisabled: function() {
            return this.entityIdStr ? false : true
        },
        params: function() { 
            return {
                current: this.page.pageNum,
                search: this.searchInput,
                size: this.page.pageSize,
                available: this.availableValue
            }
        }
    },
    methods: {
        // 搜索
        search() {
            this.page.pageNum = 1
            this.tableRefresh()
        },
        // 启用状态筛选
        stateChange(value) {
            this.page.pageNum = 1
            this.tableRefresh()
        },
        add() {
          this.addTitle = '添加'
          this.accountData = {}
          this.addDialogVisible = true
        },
        // 批量启用/禁用
        batch(batchString) {
            this.$confirm(`是否确定${batchString}账号?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(batchString === '批量启用') {
                    batchEnable({"entityIds": this.entityIdStr}).then(res => {
                        if(res.code === 200) {
                            this.$message.success(`${batchString}成功!`)
                            this.tableRefresh()
                        }
                    }).catch(err => {})
                } else if(batchString === '批量禁用') {
                    batchDisable({"entityIds": this.entityIdStr}).then(res => {
                        if(res.code === 200) {
                            this.$message.success(`${batchString}成功!`)
                            this.tableRefresh()
                        }
                    }).catch(err => {})
                } else {
                  // 批量删除
                }
            }).catch(err => {})
        },
        // 多选
        handleSelectionChange(val) {
            let entityIdArr = []
            val.forEach(item => {
                entityIdArr.push(item.guid)
            })
            this.entityIdStr = entityIdArr.join(',')
        },
        cityChange(val) {

        },
        cancleAccount() {
            this.addDialogVisible = false
        },
        submitAccount(accountData) {
          this.$refs[accountData].validate((valid) => {
            if (valid) {
              console.log('添加/编辑提交')
            }
          })
        },
        canclePwd() {
            this.pwdDialogVisible = false
        },
        submitPwd(pwdData) {
          this.$refs[pwdData].validate((valid) => {
            if (valid) {
              if(this.pwdData.newPwd !== this.pwdData.confirmPwd)
              this.$message.warning('两次输入的密码不一致, 请检查并重新输入')
              return
              console.log('密码修改提交')
            }
          })
        },
        updatePwd(row) {
          this.pwdDialogVisible = true
        },
        edit(row) {
          this.addTitle = '编辑'
          this.addDialogVisible = true
        },
        // 禁用/启用
        useChange(row) {
            this.$confirm('是否确定' + (row.available === '启用'?'禁用':'启用') + '该账号?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.updateParams.entityId = row.guid;
                this.updateParams.available = row.available === '禁用' ?  '1' : '0';
                availableUpdate(this.updateParams).then(r => {
                    if(r.code === 200) {
                        this.$message.success(row.available === '禁用' ? '启用成功!':'禁用成功!')
                        this.tableRefresh();
                    }
                }).catch(err => {});
            }).catch(e => {});
        },
        tableRefresh() {
            // this.tableLoading = true;
            // getSchoolList(this.params).then(r => {
            //     if(r.code === 200) {
            //         let data = r.data.records
            //         data.forEach(el => {
            //             el.scType = mapping.keyToVal('scType', el.scType)
            //             el.buyerType = mapping.keyToVal('buyerType', el.buyerType)
            //             el.available = mapping.keyToVal('available', el.available)
            //             el.qualityLevel = mapping.keyToVal('qualityLevel', el.qualityLevel)
            //         })
            //         this.tableData = data
            //         this.page.total = parseInt(r.data.total)
            //     }
            //     this.tableLoading = false;
            // }).catch(err => {})
        },
        // 页数改变
        pageCurrentChange(num) {
            if(num !== this.page.pageNum) {
                this.page.pageNum = num;
                this.tableRefresh();
            }
        },
        // 页数据量改变
        pageSizeChange(size) {
            if(size !== this.page.pageSize) {
                this.page.pageSize = size;
                this.tableRefresh();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .wrap {
        width: 100%;
        height: calc(100% - 40px);
        text-align: left;
        .click-link {
          cursor: pointer;
          position: absolute;
          bottom: 0;
        }
    }
    .footer {
        margin-top: 20px;
        text-align: right;
    }
</style>
